import billingCategoryCreateComponent from './billing_category.create.component';

let billingCategoryCreateModule = angular.module('billingCategoryCreate', [])

    .component('billingCategoryCreate', billingCategoryCreateComponent)

    .name;

export default billingCategoryCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/create/index.js